import { SortableColumnKeys } from "./App";
import { IBroker } from "./Broker";
import {
  ClientSummary,
  ConnectorStatusSummaryResponse,
  CompanySummaryResponse,
  CompanySummary,
} from "./Models";
import { getCompaniesUri, getCompany } from "./utils";

export interface IRepository {
  GetConnectorsAsync(token: string): Promise<ConnectorStatusSummaryResponse>;
  GetCompaniesAsync(
    page: number,
    pageSize: number,
    order: "asc" | "desc",
    sortBy: SortableColumnKeys,
    search: string,
    token: string,
    syncStatusFilter: string,
    connectionStatusFilter: string
  ): Promise<CompanySummaryResponse>;
  GetClientAsync(token: string): Promise<ClientSummary>;
  GetCompanyAsync(companyId: string, token: string): Promise<CompanySummary>;
}

export class Repository implements IRepository {
  private readonly _api: IBroker;

  constructor(broker: IBroker) {
    this._api = broker;
  }

  public GetConnectorsAsync = async (
    token: string
  ): Promise<ConnectorStatusSummaryResponse> =>
    this._api.Fetch("connectors", token);
  //Promise.resolve(JSON.parse(`{"maxVersions":[{"integration":"sage50", "version":"2.0.0.41657"}],"results":[{"count":32,"status":"unknown"},{"count":4,"status":"alive"}],"totalResults":36}`));

  public GetCompaniesAsync = async (
    page: number,
    pageSize: number,
    order: "asc" | "desc",
    sortBy: SortableColumnKeys,
    search: string,
    token: string,
    syncStatusFilter: string,
    connectionStatusFilter: string
  ): Promise<CompanySummaryResponse> =>
    this._api.Fetch(
      getCompaniesUri(
        page,
        pageSize,
        order,
        sortBy,
        search,
        syncStatusFilter,
        connectionStatusFilter
      ),
      token
    );
  //TestCompaniesResponse(page, pageSize, order, search);

  public GetCompanyAsync = async (companyId: string, token: string) => {
    return this._api.Fetch(getCompany(companyId), token);
  };

  public GetClientAsync = async (token: string): Promise<ClientSummary> =>
    this._api.Fetch("client", token);
  // Promise.resolve(JSON.parse('{"clientName":"Vandana"}'));
}
